import * as wConst from "../consts/website-consts.js";

export const InitState = {
  FeaturedLinks: {
    Loaded: false,
    Result: {
      Code: 500,
      Message: "There is no results yet"
    }
  },
  Categories: {
    Loaded: false,
    Result: {
      Code: 500,
      Message: "There is no results yet"
    },
  },
  SubmitLink: {
    Posting: false,
    ApiResult: {
      Code: 500, Message: "Not posted..."
    }
  },
  Link: {
    Loaded: false,
    ApiResult: {Code: 500, Message: "New"}
  },
  SubLinks: {
    Loading: false,
    Loaded: false,
    ApiResult: {Code: 500, Message: "New"}
  }

};

export const linkReducer = (state = InitState, action) => {
  const ResetState = {
    FeaturedLinks: {
      Loaded: false,
      ApiResult: {
        Code: 500,
        Message: "There is no results yet"
      }
    },
    Categories: {
      Loaded: false,
      ApiResult: {
        Code: 500,
        Message: "There is no results yet"
      },
    },
    SubmitLink: {
      Loaded: false,
      Posting: false,
      ApiResult: {
        Code: 500, Message: "Not posted..."
      }
    },
    Link: {
      Loaded: false,
      ApiResult: {Code: 500, Message: "New"}
    },
    SubLinks: {
      Loading: false,
      Loaded: false,
      ApiResult: {Code: 500, Message: "New"}
    }

  };

  switch (action.type) {
    case wConst.RESET_STATE: {
      state = {...ResetState};
      break;
    }
    case wConst.FETCH_FEATUREDLINKS_PENDING: {
      state = {...state, FeaturedLinks: {...state.FeaturedLinks, Loaded: false}};
      break;
    }
    case wConst.FETCH_FEATUREDLINKS_REJECTED: {
      state = {...state, FeaturedLinks: {ApiResult: action.payload, Loaded: true}};
      break;
    }
    case wConst.FETCH_FEATUREDLINKS_FULLFILLED: {
      state = {...state, FeaturedLinks: {ApiResult: action.payload, Loaded: true}};
      break;
    }
    case wConst.FETCH_CATEGORYLINKS_PENDING: {
      state = {...state, Categories: {...state.Categories, Loaded: false}};
      break;
    }
    case wConst.FETCH_CATEGORYLINKS_REJECTED: {
      state = {...state, Categories: {ApiResult: action.payload, Loaded: true}};
      break;
    }
    case wConst.FETCH_CATEGORYLINKS_FULLFILLED: {
      state = {...state, Categories: {ApiResult: action.payload, Loaded: true}};
      break;
    }
    case wConst.SUBMIT_LINK_PENDING: {
      state = {...state, SubmitLink: {...state.SubmitLink, Posting: true, Loaded: false }}
      break;
    }
    case wConst.SUBMIT_LINK_REJECTED: {
      state = {...state, SubmitLink: {...state.SubmitLink, Posting: false, Loaded: false }}
      break;
    }
    case wConst.SUBMIT_LINK_FULFILLED: {
      state = {...state, SubmitLink: {...state.SubmitLink, Posting: false, Loaded: true }}
      break;
    }
    case wConst.GET_LINK_PENDING: {
      state = {...state, Link: {...state.Link, Loaded: false }}
      break;
    }
    case wConst.GET_LINK_REJECTED: {
      state = {...state, Link: {Loaded: true, ApiResult: action.payload }}
      break;
    }
    case wConst.GET_LINK_FULFILLED: {
      state = {...state, Link: {Loaded: true, ApiResult: action.payload }}
      break;
    }
    case wConst.GET_SUBLINKS_CLEAR: {
      state = {...state, SubLinks: {
          Loading: false,
          Loaded: false,
          ApiResult: {Code: 500, Message: "New"}
        }};
      break;
    }
    case wConst.GET_SUBLINKS_PENDING: {
      state = {...state, SubLinks: {...state.SubLinks, Loaded: false, Loading: true }}
      break;
    }
    case wConst.GET_SUBLINKS_REJECTED: {
      state = {...state, SubLinks: {Loaded: true, Loading: false, ApiResult: action.payload }}
      break;
    }
    case wConst.GET_SUBLINKS_FULFILLED: {
      state = {...state, SubLinks: {Loaded: true, Loading: false, ApiResult: action.payload }}
      break;
    }
    default: {

    }
  }
  return state;
};


